import * as React from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useTranslation } from "react-i18next";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";

export default function DisplayGeneratedText({ text, saveAndRefetchText }) {
  const [editMode, setEditMode] = React.useState(false);
  const { t } = useTranslation();

  const [editableText, setEditableText] = React.useState(text);

  React.useEffect(() => {
    setEditableText(text);
  }, [text]);
  return (
    <>
      {editMode ? (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <TextField
            variant="outlined"
            size="small"
            value={editableText}
            multiline={true}
            // rows={10}
            inputProps={{ style: { fontSize: 15 } }}
            sx={{ mx: 2, mt: 1 }}
            onChange={(e) => setEditableText(e.target.value)}
          />
          <Box sx={{ display: "flex", flexDirection: "row", mt: 1.5 }}>
            <Button
              variant="contained"
              sx={{
                width: 120,
                ml: 4,
                textTransform: "none",
                borderRadius: 20,
              }}
              onClick={() => {
                saveAndRefetchText(editableText);
                setEditMode(false);
              }}
            >
              {t("save")}
            </Button>
            <Button
              variant="outlined"
              sx={{
                width: 120,
                ml: 3,
                textTransform: "none",
                borderRadius: 20,
              }}
              onClick={() => {
                setEditableText(text);
                setEditMode(false);
              }}
            >
              {t("discard")}
            </Button>
          </Box>
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <IconButton
            sx={{ ml: 1, width: 35, height: 35 }}
            onClick={() => setEditMode(true)}
          >
            <EditOutlinedIcon />
          </IconButton>
          <Typography
            sx={{
              whiteSpace: "pre-line",
              mt: 1,
              mx: 2,
              fontFamily: "Inter",
              fontSize: 14,
            }}
          >
            {text}
          </Typography>
        </Box>
      )}
    </>
  );
}
